export default "__VITE_ASSET__95a9af2a__"